import { render, staticRenderFns } from "./PaymentsCharts.vue?vue&type=template&id=3e649d96&"
import script from "./PaymentsCharts.vue?vue&type=script&lang=js&"
export * from "./PaymentsCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports